import {
  PRIORITY,
  CHANGE_VERSION,
  ASSIGN_TO,
  ASSIGNED_USER_NAME,
  ASSIGNED_USER_ID,
  TEAM,
  ASSIGN_TO_INITIAL_VALUE,
  ASSIGNED_USER_ID_INITIAL_VALUE,
  ASSIGNED_USER_NAME_INITIAL_VALUE,
  TEAM_INITIAL_VALUE,
  UPDATE_STATUS,
} from './base';
import {
  RECORD_LINKAGE,
  RECORD_LINKAGE_INITIAL_VALUES,
} from './record-linkage';

export const JOB_TEMPLATE_FIELDS = {
  ID: 'id',
  NAME: 'name',
  DESCRIPTION: 'description',
  TASK_TEMPLATES: 'taskTemplates',
  METADATA: 'metadata',
  TEAM: 'team',
  CHANGE_VERSION,
  RECORD_LINKAGE,
};

const INDEXES = [
  'jobTemplateName',
  'linkedRecord',
];

export const JOB_TEMPLATE_SEARCHABLE_INDEXES = [
  {
    labelId: 'ui-task-list.search.all',
    value: '',
  },
  ...INDEXES.map(index => ({
    labelId: `ui-task-list.jobTemplate.search.${index}`,
    value: index,
  })),
];

export const TASK_TEMPLATES_FIELDS = {
  ID: 'id',
  NAME: 'name',
  DESCRIPTION: 'description',
  PRIORITY: 'priority',
  UPDATE_STATUS: 'updateStatus',
  ASSIGN_TO,
  ASSIGNED_USER_NAME,
  ASSIGNED_USER_ID,
  TEAM,
};

export const TASK_TEMPLATES_INITIAL_VALUES = {
  [TASK_TEMPLATES_FIELDS.NAME]: '',
  [TASK_TEMPLATES_FIELDS.DESCRIPTION]: '',
  [TASK_TEMPLATES_FIELDS.PRIORITY]: PRIORITY.LOW,
  [TASK_TEMPLATES_FIELDS.UPDATE_STATUS]: UPDATE_STATUS.ADD,
  dueDate: '',
  startDate: '',
  [TASK_TEMPLATES_FIELDS.ASSIGN_TO]: ASSIGN_TO_INITIAL_VALUE,
  [TASK_TEMPLATES_FIELDS.ASSIGNED_USER_NAME]: ASSIGNED_USER_NAME_INITIAL_VALUE,
  [TASK_TEMPLATES_FIELDS.ASSIGNED_USER_ID]: ASSIGNED_USER_ID_INITIAL_VALUE,
  [JOB_TEMPLATE_FIELDS.TEAM]: TEAM_INITIAL_VALUE,
};

export const JOB_TEMPLATE_INITIAL_VALUES = {
  [JOB_TEMPLATE_FIELDS.NAME]: '',
  [JOB_TEMPLATE_FIELDS.DESCRIPTION]: '',
  [JOB_TEMPLATE_FIELDS.TASK_TEMPLATES]: [TASK_TEMPLATES_INITIAL_VALUES],
  [JOB_TEMPLATE_FIELDS.RECORD_LINKAGE]: RECORD_LINKAGE_INITIAL_VALUES,
};

export const JOB_TEMPLATES_DEFAULT_SORT_FIELD = JOB_TEMPLATE_FIELDS.NAME;
